<form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col justify-center items-start w-full h-auto" #formContainer>
  <label #labelElement for="item" class="text-label text-start w-full">
    {{ config()?.label }} 
    <b class="text-sub-label">{{ config()?.subLabel }}</b>
  </label>

  <div class="flex justify-between items-center space-x-2 w-full bg-white p-2 rounded-sm border border-blue-800">

    <!-- Año -->
    <div class="w-1/3">
      <select class="w-full p-2 border rounded border-blue-800" formControlName="year" (change)="onMonthOrYearChange()">
        <option value="">Año</option>
        @for (year of allowedYears; track $index) {
          <option [value]="year">{{ year }}</option>
        }
      </select>
    </div>

    <!-- Mes -->
    <div class="w-1/3">
      <select class="w-full p-2 border rounded border-blue-800" formControlName="month" (change)="onMonthOrYearChange()">
        <option value="">Mes</option>
        @for (month of months; track $index) {
          <option [value]="month.value">{{ month.name }}</option>
        }
      </select>
    </div>

    <!-- Día -->
    <div class="w-1/3">
      <select class="w-full p-2 border rounded border-blue-800" formControlName="day" (change)="resetInactivityTimer()">
        <option value="">Día</option>
        @for (day of daysInMonth; track $index) {
          <option [value]="day">{{ day }}</option>
        }
      </select>
    </div>
  </div>

  @if (showRequiredError()) {
    <div class="text-red-500 text-[10px] mt-1 text-start w-full">
      @if (isInactiveError()) {
        Por favor completa tu fecha de nacimiento
      } @else {
        Por favor completa tu fecha de nacimiento
      }
    </div>
  }
  
  <!-- Mensaje de error para edad menor a 18 años -->
  @if (showAgeError()) {
    <div class="text-red-500 text-[10px] mt-1 text-start w-full">
      Debes tener al menos 18 años
    </div>
  }
</form>